module.exports = __webpack_public_path__ + "static/media/cloud-d2-v3.9f66772d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-d2-v3.svg
// module id = 102
// module chunks = 0